import { Component, OnInit, ViewChild } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { GrantsRegistrationsViewModalComponent } from './grants-registrations-view-modal/grants-registrations-view-modal.component';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ClientGridComponent } from 'src/app/common/client-grid/client-grid.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-grants-registrations',
  templateUrl: './grants-registrations.component.html',
  styleUrls: ['./grants-registrations.component.scss']
})
export class GrantsRegistrationsComponent implements OnInit {
  @ViewChild(ClientGridComponent) clientgrid;

  gridApi: GridApi;
  columnDefs;
  operations;
  rowData;
  advanceSearch;
  selectedRow;
  isSettings: boolean = true;
  Tempoperations: { name: string; id: string; }[];
  Tempoperations1: { name: string; id: string; }[];
  IsResendRequired: boolean = true;
  caseDetails;
  tempoperations;
  GrantsRegistartionsForm: UntypedFormGroup;
  collapesedOrNot: boolean = false;
  orgTypeList: any[];
  orgCode: string=null;
  taxStatusList: any[];
  Statuslist: any[] = [];

  constructor(
    public route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private userService: UserService

  ) {

  }

  ngOnInit() {
    this.Statuslist.push({ label: "All", value: "" })
    this.Statuslist.push({ label: "Blocked", value: "0" })
    this.Statuslist.push({ label: "Unblocked", value: "1" })

    this.collapesedOrNot = false;

    this.GrantsRegistartionsForm = new UntypedFormGroup({
      Name: new UntypedFormControl(""),
      Type: new UntypedFormControl(""),
      TaxStatus: new UntypedFormControl(""),
      TaxID: new UntypedFormControl(""),
      FullName: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      City: new UntypedFormControl(""),
      State: new UntypedFormControl(""),
      Country: new UntypedFormControl(""),
      OrganizationName: new UntypedFormControl(""),
      Address: new UntypedFormControl(""),
      FirstName: new UntypedFormControl(""),
      LastName: new UntypedFormControl(""),
      Email: new UntypedFormControl(""),
      PhoneNumber: new UntypedFormControl(""),
      OtherPhoneNumber: new UntypedFormControl(""),
      FaxNumber: new UntypedFormControl(""),
      IsYourOrganizationAffiliated: new UntypedFormControl(""),
      IsYourOrganizationAccrediated: new UntypedFormControl(""),
    });

    this.columnDefs = [
      {
        "headerName": "Registration ID",
        "field": "RegistrationID",
      },
      {
        "headerName": "Full Name",
        "field": "FullName"
      },
      {
        "headerName": "Organization Name",
        "field": "Name",
      },
      {
        "headerName": "Organization Type",
        "field": "Type"
      },
      // {
      //   "headerName": "Tax Status",
      //   "field": "TaxStatus"
      // },

      {
        "headerName": "Status",
        "field": "Status"
      }
    ];
    this.GetMasterData();
    this.getSummaryData();

    this.caseDetails = [
      {
        "caseSet": {
          "caseHeading": "",
          "caseData": [
            {
              "label": "Organization Name ",
              "value": "Name"
            },
            {
              "label": "Organization Type",
              "value": "Type"
            },
            {
              "label": "Tax Status",
              "value": "TaxStatus"
            },
            {
              "label": "Tax ID",
              "value": "TaxID"
            },
            {
              "label": "Country",
              "value": "Country"
            },
            {
              "label": "State",
              "value": "State"
            },
            {
              "label": "City",
              "value": "City"
            },
            {
              "label": "Address",
              "value": "Address"
            },
            {
              "label": "First Name",
              "value": "FirstName"
            },
            {
              "label": "Last Name",
              "value": "LastName"
            },
            {
              "label": "Email ID",
              "value": "Email"
            },
            {
              "label": "Phone Number",
              "value": "PhoneNumber"
            },
            {
              "label": "Other Phone Number",
              "value": "OtherPhoneNumber"
            },
            {
              "label": "Fax Number",
              "value": "FaxNumber"
            },
            {
              "label": "is your Organization Acreediated?",
              "value": "IsYourOrganizationAccrediated"
            },
            {
              "label": "is your Organization with a Govt agency?",
              "value": "IsYourOrganizationAffiliated"
            }
          ]

        }
      }];
  }
  setRowOperations(rowData: any[]) {
    this.isSettings = true;
    rowData.forEach(element => {
      this.Tempoperations = [];
      this.Tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
      if (element.IsTempPwd == true && element.Recordstate==1) {
        this.Tempoperations.push(
          {
            "name": "Resend Email",
            "id": "Resend"
          });
      }
     
        element["Operations"] = this.Tempoperations.map(operation => {
          return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      
    });
    this.operations = this.Tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    // this.clearCaseDetail();
    //this.setSummaryData();
    // this.SearchClear();
    return rowData;

  }

  getSummaryData() {
    this.SearchClear();
    this.summaryService.getApplicationSummary("api/gm/getsummary").subscribe(summary => {
      this.rowData = summary;
      this.setRowOperations(this.rowData);
    });
  }


  GetMasterData() {
    this.orgTypeList = [];
    this.taxStatusList = [];
    if (this.orgCode == undefined || this.orgCode == null) {
      this.orgCode = this.userService.getOrgCode();
    }

    this.summaryService.GetMasterScreenData("api/appuser/getmasterdata/"+this.orgCode+"/-2").subscribe(summary => {
      this.orgTypeList = summary["MasterData1"];
      this.orgTypeList = [{ label: "All", value: null, checked: true }].concat(this.orgTypeList);
      this.taxStatusList = summary["MasterData2"];
      this.taxStatusList = [{ label: "All", value: null, checked: true }].concat(this.taxStatusList);

    });
  }

  SearchClear() {
    this.GrantsRegistartionsForm = new UntypedFormGroup({
      Name: new UntypedFormControl(""),
      Type: new UntypedFormControl(""),
      TaxStatus: new UntypedFormControl(""),
      TaxID: new UntypedFormControl(""),
      FullName: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      City: new UntypedFormControl(""),
      State: new UntypedFormControl(""),
      Country: new UntypedFormControl(""),
      OrganizationName: new UntypedFormControl(""),
      Address: new UntypedFormControl(""),
      FirstName: new UntypedFormControl(""),
      LastName: new UntypedFormControl(""),
      Email: new UntypedFormControl(""),
      PhoneNumber: new UntypedFormControl(""),
      OtherPhoneNumber: new UntypedFormControl(""),
      FaxNumber: new UntypedFormControl(""),
      IsYourOrganizationAffiliated: new UntypedFormControl(""),
      IsYourOrganizationAccrediated: new UntypedFormControl(""),
    });
  }

  AdvanceSearch() {

    var formData = this.GrantsRegistartionsForm.value;
    this.selectedRow = null;
    this.onSelectionChanged(null);
    this.clientgrid.clearCase(this.caseDetails);

    this.summaryService.PostSearchSummary("api/gm/getsummarysearch", formData).subscribe(summary => {
      this.rowData = summary;
    });
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    let modalRef = this.modalService.open(GrantsRegistrationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: this.selectedRow['ID'], heading: 'View', ORGCODE: this.orgCode }
    }
  }

  add() {
    let modalRef = this['self'].modalService.open(GrantsRegistrationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: null
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  edit() {
    let modalRef = this['self'].modalService.open(GrantsRegistrationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: this['self'].selectedRow['ID'],  ORGCODE: this['self'].orgCode }
    };
    modalRef.result.then((result) => {
      this['self'].getSummaryData();
    });
  }

  Resend() {
    let id = this['self'].selectedRow["ID"];
    // let OrgId = this['self'].orgId;
    this['self'].summaryService.resendUserEmail(id, "1").subscribe(summary => {
      if (summary != null && summary.Status == 0) {
        this['self'].commonService.SuccessBanner(summary.Message);
      } else if (summary.ErrorCode == "MAILEXCEPTION") {
        this['self'].commonService.ValidationBanner("Unable to send email to users. Please try again");
      }
    });
  }

}
